
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Alarm_code } from '../models/index';
import { AppConstants } from '../constant/app.constants';

@Injectable()
export class User_alarmService {
    constructor(private http: HttpClient) {
    }

    getUser_alarm(alarm_code: Alarm_code) {
        return this.http.post<any>(AppConstants.SITE_URL + 'user_alarm/get_user_alarm', alarm_code);
    }

    getUser_alarmById(id) {
        return this.http.post<any>(AppConstants.SITE_URL + 'user_alarm/get_user_alarmById', { id: id });
    }


    getUser_alarmByPlantOrMachineId(plantMachineId) {
        return this.http.post<any>(AppConstants.SITE_URL + 'user_alarm/get_user_alarmByPlantOrMachineId', plantMachineId);
    }

    saveUser_alarm(alarm_code) {
        return this.http.post<any>(AppConstants.SITE_URL + 'user_alarm/save_user_alarm', alarm_code);
    }

    deleteUser_alarm(id) {
        return this.http.post<any>(AppConstants.SITE_URL + 'user_alarm/delete_user_alarm', { id: id });
    }

    delete_machine_alarms(id) {
        return this.http.post<any>(AppConstants.SITE_URL + 'alarms/delete_machine_alarms', { machine_id: id });
    }


    delete_plant_alarms(id) {
        return this.http.post<any>(AppConstants.SITE_URL + 'alarms/delete_plant_alarms', { plant_id: id });
    }

    getUser_alarmLog(dtInstance) {
        return this.http.post<any>(AppConstants.SITE_URL + 'alarms/get-alarm-log', dtInstance);
    }

}



// WEBPACK FOOTER //
// /var/www/hqsol/hqsol-live/app/src/app/services/user_alarm.service.ts